'use client'
import { ToastError, ToastSuccess } from '@/app/common/ToastNotifications';
import React, { createContext, useContext, useEffect, useState } from 'react'

let CartProvider = createContext();
export default function CartContext({ children }) {
    let [cart, setcart] = useState([])
    const addcartdata = (value, quantity) => {
        let data = value
        data.Quantity = quantity
        let getlocalstoragedata = JSON.parse(localStorage.getItem('cartdata'))
        let checkexisting = getlocalstoragedata?.find((item) => {
            return item._id === data._id
        })

        if (checkexisting) {
            ToastError("Data Already Exists")
        }
        else {
            if (!Array.isArray(getlocalstoragedata)) {
                getlocalstoragedata = [data]
            }
            else {
                getlocalstoragedata[getlocalstoragedata?.length] = data
            }
            let storelocal = localStorage.setItem('cartdata', JSON.stringify(getlocalstoragedata))
            ToastSuccess("Data Added Successfully")
            return setcart(JSON.parse(localStorage.getItem('cartdata')))
        }
    }


    const increasequantity = (id) => {
        if (!Array.isArray(cart)) return;

        const updatedCart = cart.map((item) => {
            if (item._id === id) {
                return {
                    ...item,
                    Quantity: item.Quantity + 1,
                };
            }

            return item;
        });

        setcart(updatedCart);

        localStorage.setItem(
            "cartdata",
            JSON.stringify(updatedCart)
        );
    };


    const decreasequantity = (id) => {
        if (!Array.isArray(cart)) return;

        const updatedCart = cart.map((item) => {
            if (item._id === id && item.Quantity > item.Product_MOQ) {
                return {
                    ...item,
                    Quantity: item.Quantity - 1,
                };
            }

            return item;
        });

        setcart(updatedCart);

        localStorage.setItem(
            "cartdata",
            JSON.stringify(updatedCart)
        );
    };


    const removefromcart = (id) => {
        let removeddata = cart.filter((item) => {
            if (item._id !== id) {
                setcart(item)
                return item
            }
        })
        localStorage.setItem(
            "cartdata",
            JSON.stringify(removeddata)
        );
        setcart(removeddata)
    };

    useEffect(() => {
        setcart(JSON.parse(localStorage.getItem('cartdata')) || [])
    }, [])
    return (
        <CartProvider.Provider
            value={{
                cart,
                addcartdata,
                increasequantity,
                decreasequantity,
                removefromcart
            }}
        >
            {children}
        </CartProvider.Provider>
    )
}

export const useCart = () => {
    return useContext(CartProvider)
}